/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CdvxInfo } from './cdvxInfo';


export interface InventoryStats { 
    cloud_dvx_stats: Array<CdvxInfo>;
    protected_vm_count?: number;
    rwr_protected_vm_count?: number;
    vm_count_plans?: number;
}

